/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext, useMemo } from "react";
import AppContext from "../../../../Store/AppContext";
import {
  Listar as ListarDocumento,
  ListarDocsPorCriterio,
  Detalhes as DetalhesDocumento,
  Remover as RemoverDocumento,
  Incluir as IncluirDocumento,
  Atualizar as AtualizarDocumento
} from "../../../../Services/Docs";
import {
  Listar as ListarTipoDocs,
  ListarSubTipoDocs
} from "../../../../Services/TipoDocs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import { Listar as ListarGrupoUsuario } from "../../../../Services/GrupoUsuario";
import { ListarSimples as ListarUsuario } from "../../../../Services/Usuario";
import { useHistory } from "react-router-dom";
import { validarPermissoesPagina } from "../../../../Utils/validarPermissoesPagina";
import { DownloadArquivoFisico } from "../../../../Services/Download";
export const DocumentoContext = createContext();

const tituloTela = "Documento";

/* === Estrutura mínima para o cadastro inicial === */
const defaultData = {
  docsId: 0,
  subTipoDocsId: 0,
  docsNome: "",
  docsDescricao: "",
  docsTags: "",
  docsConfidencialidade: "", // P/R/C
  docsStatus: "",            // A/I
  docsDataValidade: "",      // yyyy-MM-dd
  grupoUsuarioList: [],
  usuarioList: [],
  documentoList: [],
};

/* === Pesquisa: somente por nome === */
const searchData = {
  tipoDocsId: 0,
  subTipoDocsId: 0,
  criterioBusca: "",
};

const handleDownloadArquivoFisico = async (arquivoNome, arquivoNomeDownload) => {
  try {
    await DownloadArquivoFisico(arquivoNome, arquivoNomeDownload);
  } catch (error) {
    console.error("Erro ao baixar arquivo:", error);
  }
};

const columnsDefinition = [
  { text: "Id", dataField: "docsId", hidden: true },
  { text: "Nome", dataField: "docsNome", headerStyle: { width: "450px" }, sort: true },
  {
    text: "Confid.",
    dataField: "docsConfidencialidade",
    headerStyle: { width: "120px" },
    sort: true,
    formatter: (cell) =>
      cell === "C" ? <span className="badge badge-danger">Confidencial</span>
        : cell === "R" ? <span className="badge badge-warning">Restrito</span>
          : <span className="badge badge-success">Público</span>,
  },
  {
    text: "Status",
    dataField: "docsStatus",
    headerStyle: { width: "100px" },
    sort: true,
    formatter: (cell) =>
      cell === "A" ? <span className="badge badge-success">Ativo</span>
        : <span className="badge badge-danger">Inativo</span>,
  },
  {
    text: "Arquivo",
    dataField: "docsId",
    headerStyle: { width: "60px" },
    formatter: (cell, row) => (
      <div style={{ width: "100%", textAlign: "center" }}>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={() => handleDownloadArquivoFisico(`${row.docsPath}.${row.docsExtensao}`, row.docsNomeOrig)}
        >
          <FontAwesomeIcon style={{ fontSize: 10, marginRight: 5 }} icon={faDownload} /> Baixar
        </button>
      </div>
    ),
  },
];

function initialState() {
  return {
    searchData: searchData,
    resultSearch: [],
    columnsDefinition: columnsDefinition,
    data: defaultData,
    formDisabled: true,
    tiposDocs: [],
    subTiposDocs: [],
    grupoUsuarioList: [],
    usuarioList: [],
    documentoList: [],
    subTipo: null,
  };
}

const DocumentoProvider = ({ children }) => {
  const { showLoading, hideLoading, showMessage, setTituloTela } = useContext(AppContext);
  const [values, setValues] = useState(initialState());
  let history = useHistory();

  const obterSubtipos = async (tipoDocsId) => {

    const [subTiposResp] = await Promise.all([
      ListarSubTipoDocs({ tipoDocsId })
    ]);


    return (subTiposResp.success ? subTiposResp.subTiposDocs : [])
  };

  // const obterSubtipos = async (tipoDocsId) => {

  //   const [subTiposResp] = await Promise.all([
  //     ListarSubTipoDocs({ tipoDocsId })
  //   ]);


  //   return (subTiposResp.success ? subTiposResp.subTiposDocs.filter((item) => item.subTipoDocsStatus === "A") : [])
  // };

  async function loadDependences() {
    try {

      const [permissoesPaginaAux, tiposResp, responseListarGrupoUsuario, responseListarUsuario, responseListarDocumento] = await Promise.all([
        validarPermissoesPagina(),
        ListarTipoDocs({}),
        ListarGrupoUsuario({}),
        ListarUsuario({}),
        ListarDocumento({})
      ]);


      const tiposDocs = ((tiposResp.success ? tiposResp.tiposDocs : []) || [])
        .filter((item) => item.tipoDocsStatus === "A")
        .map((sub) => ({
          value: sub.tipoDocsId,
          label: sub.tipoDocsNome,
        }));

      const grupoUsuarioList = await responseListarGrupoUsuario.gruposUsuario;
      const usuarioList = await responseListarUsuario.usuarios;
      const documentoList = await responseListarDocumento.documentos;

      return {
        permissoesPagina: permissoesPaginaAux,
        tiposDocs,
        grupoUsuarioList,
        usuarioList,
        documentoList,
      };
    } catch (err) {
      // fallback seguro
      return {
        permissoesPagina: [],
        tiposDocs: [],
        grupoUsuarioList: [],
        usuarioList: [],
        documentoList: []
      };
    }
  }


  const resetScreen = () => {
    showLoading();
    (async () => {
      const dependencias = await loadDependences();
      setTituloTela(tituloTela);
      setValues({
        ...initialState(),
        permissoesPagina: await dependencias.permissoesPagina,
        tiposDocs: await dependencias.tiposDocs,
        grupoUsuarioList: await dependencias.grupoUsuarioList,
        usuarioList: await dependencias.usuarioList,
        documentoList: await dependencias.documentoList,
      });
      hideLoading();
    })();
  };

  const searchHandler = async () => {
    showLoading();
    const responseListarDocsPorCriterio = await ListarDocsPorCriterio(values.searchData);

    if (!responseListarDocsPorCriterio.success) {
      showMessage("Erro", "Erro Inesperado durante a pesquisa.");
      hideLoading();
      return;
    }

    const resultSearchData = await (responseListarDocsPorCriterio.documentos || []);
    resultSearchData.map((data) => (data.Id = data.docsId));

    setValues({ ...values, resultSearch: resultSearchData });

    if (resultSearchData.length === 0) showMessage("Alerta", "Nenhum registro encontrado.");
    hideLoading();
  };

  const removeHandler = async (id) => {
    showLoading();
    const responseRemover = await RemoverDocumento(id);

    if (!responseRemover.success) {
      hideLoading();
      showMessage("Erro", `Erro durante a exclusão: ${responseRemover.message}`);
      return;
    }
    searchHandler();
    hideLoading();
    showMessage("Sucesso", "Registro excluido.");
  };

  const getDetailHandler = async (id) => {
    showLoading();
    const dependencias = await loadDependences();
    const docId = Number(id) || 0;

    if (docId > 0) {
      const responseDetalhes = await DetalhesDocumento(docId);
      const { success, documento } = await responseDetalhes;

      if (!success) {
        showMessage("Erro", "Erro ao buscar os detalhes do registro.");
        setValues({
          ...values,
          data: defaultData,
          permissoesPagina: await dependencias.permissoesPagina,
          tiposDocs: await dependencias.tiposDocs,
          grupoUsuarioList: await dependencias.grupoUsuarioList,
          usuarioList: await dependencias.usuarioList,
          documentoList: await dependencias.documentoList,
          subTipo: null,
          subTiposDocs: [],
        });
      } else {

        let tiposDocs = await dependencias.tiposDocs;
        const idTipo = Number((documento && documento.tipoDocsId) || 0);
        let tipoDoc = tiposDocs.find((o) => o.value === idTipo) || null;


        let subtiposBase = await obterSubtipos(idTipo);

        const subTiposDocs = subtiposBase

          .map((sub) => ({
            value: sub.subTipoDocsId,
            label: sub.subTipoDocsNome,
          }));

        const idSubTipo = Number((documento && documento.subTipoDocsId) || 0);
        const subTipo = subTiposDocs.find((o) => o.value === idSubTipo) || null;


        setValues({
          ...values,
          data: { ...defaultData, ...(documento || {}) },
          permissoesPagina: await dependencias.permissoesPagina,
          grupoUsuarioList: await dependencias.grupoUsuarioList,
          usuarioList: await dependencias.usuarioList,
          documentoList: await dependencias.documentoList,
          tipoDoc,
          tiposDocs,
          subTiposDocs,
          subTipo,
        });
      }
    } else {
      setValues({
        ...values,
        data: { ...defaultData, docsId: 0 },
        permissoesPagina: await dependencias.permissoesPagina,
        tiposDocs: await dependencias.tiposDocs,
        grupoUsuarioList: await dependencias.grupoUsuarioList,
        usuarioList: await dependencias.usuarioList,
        documentoList: await dependencias.documentoList,
        subTipo: null,
        subTiposDocs: [],
        formDisabled: false,
      });
    }
    hideLoading();
  };

  const createData = async () => {
    showLoading();
    const responseIncluir = await IncluirDocumento(values.data);
    if (!responseIncluir.success) {
      hideLoading();
      showMessage("Erro", `Erro ao criar o registro: ${responseIncluir.message}`);
      responseIncluir.errors.map((erro) => showMessage("Erro", erro.errorMessage));
      return;
    }

    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro criado.");
    history.goBack();
  };

  const editHandler = () => setValues({ ...values, formDisabled: false });

  const updateData = async () => {
    showLoading();
    const responseAtualizar = await AtualizarDocumento(values.data);
    if (!responseAtualizar.success) {
      hideLoading();
      showMessage("Erro", `Erro ao atualizar o registro: ${responseAtualizar.message}`);
      return;
    }
    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro atualizado.");
    history.goBack();
  };

  const saveHandler = async () => {
    if (values.data.docsId === 0) await createData();
    else await updateData();
  };

  const cancelHandler = () => {
    setValues({ ...values, data: defaultData, formDisabled: true });
  };



  const styleSelect = useMemo(() => ({
    control: (base) => ({
      ...base,
      minHeight: 38,
      height: 38,
      fontSize: 15,
      backgroundColor: "#efefef",
    }),
    valueContainer: (base) => ({
      ...base,
      height: 38,
      padding: '0 10px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 38,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  }), []);

  return (
    <DocumentoContext.Provider
      value={{
        showMessage,
        values,
        setValues,
        resetScreen,
        searchHandler,
        cancelHandler,
        removeHandler,
        saveHandler,
        getDetailHandler,
        editHandler,
        handleDownloadArquivoFisico,
        styleSelect,
        obterSubtipos
      }}
    >
      {children}
    </DocumentoContext.Provider>
  );
};

export default DocumentoProvider;
